<app-page-header avatarHeader="true" [loadingInitialData]="loadingInitialData" [initials]="user?.initials">
    {{ pageTitle }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<app-details-card-container [actionLines]="lines"
                            [showActions]="true"
                            [actions]="actions"
                            [loadingSubject$]="loadingSubject$"
                            (actionClicked)="$event.callback()">
    <mat-card>
        <mat-card-title>{{ 'Details' }}</mat-card-title>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!user" combineLines>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Email' }}</span>
                    <span matListItemLine>{{ user?.email }}</span>
                </mat-list-item>

                <mat-list-item>
                    <span matListItemTitle>{{ 'Phone' }}</span>
                    <span matListItemLine>{{ user?.memberships[0].profile.phone ? (user?.memberships[0].profile.phone | legfiPhone) : '--' }}</span>
                </mat-list-item>

                <mat-list-item>
                    <span matListItemTitle>{{ 'Role' }}</span>
                    <span matListItemLine>{{ user?.propertyManagementCompanyUser ? 'Property Manager' : 'Community Manager' }}</span>
                </mat-list-item>
            </mat-list>
            <mat-list [loadingList]="!user" fullWidthLines>
                <mat-list-item *limitListItems="3, data: organizationsList; let item; let isFirst = first">
                    <span *ngIf="isFirst" matListItemTitle>{{ 'Managed Communities' }}{{ item?.total }}</span>
                    <a *ngIf="item?.name && item?.id"
                       [routerLink]="['/pmc', pmcId, 'communities', item.id, 'details']"
                       [innerHTML]="item.name"
                       linkButton matListItemLine>
                    </a>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>
</app-details-card-container>
